import { render } from "./AddButton.vue?vue&type=template&id=2c1581a4&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=2c1581a4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1581a4"],['__file',"src/views/ProductManage/ModelManagement/components/MotorPageComponent/AddButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c1581a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c1581a4', __exports__)) {
    api.reload('2c1581a4', __exports__)
  }
  
  module.hot.accept("./AddButton.vue?vue&type=template&id=2c1581a4&scoped=true", () => {
    api.rerender('2c1581a4', render)
  })

}


export default __exports__